var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 8.74999V5.66666C16.6666 4.26653 16.6666 3.56646 16.3942 3.03168C16.1545 2.56128 15.772 2.17882 15.3016 1.93914C14.7668 1.66666 14.0668 1.66666 12.6666 1.66666H7.33331C5.93318 1.66666 5.23312 1.66666 4.69834 1.93914C4.22793 2.17882 3.84548 2.56128 3.6058 3.03168C3.33331 3.56646 3.33331 4.26653 3.33331 5.66666V14.3333C3.33331 15.7335 3.33331 16.4335 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0608C5.23312 18.3333 5.93318 18.3333 7.33331 18.3333H9.99998M11.6666 9.16666H6.66665M8.33331 12.5H6.66665M13.3333 5.83332H6.66665M15 17.5V12.5M12.5 15H17.5",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/Activity.0db0da23526c435a6dc50bc146482a26.svg";
export { ForwardRef as ReactComponent };